import { computed, ref } from 'vue';
import { useStore } from '@/utils/vue-api';
import i18n, { changeLocaleLang, getLanguageByType, EN, ZH, ZH_HK } from '@/locales';
import I18_CN_ICON from '@/assets/images/i18-zh-cn.png';
import I18_HK_ICON from '@/assets/images/i18-zh-hk.png';
import I18_EN_ICON from '@/assets/images/i18-en.png';
import { useCommonData } from '@/hooks';

/**
 * 语言切换核心逻辑
 * 提供语言列表计算和切换逻辑，UI展示由各组件自行处理
 */
export function useLanguageSwitch() {
	const store = useStore();

	const cacheEnterLanguage = ref(i18n.locale);

	const enabledLangList = computed(() => {
		const enabledLang = store.getters.getPageList
			.filter(v => v.languageSwitch)
			.map(v => getLanguageByType(v.languageType));
		return enabledLang;
	});

	// 可用语言列表计算
	const getLanguageList = computed(() => {
		const currentLang = cacheEnterLanguage.value;
		const composeLang = [...enabledLangList.value, currentLang];
		return [...new Set(composeLang)];
	});

	const { viewInIframe } = useCommonData();
	// 是否显示语言切换按钮
	const showLanguageBtn = computed(() => {
		if (getLanguageList.value.length <= 1) return false;
		return true;
	});

	// 语言切换处理
	const handleLangChange = () => {
		if (viewInIframe.value) return false;
		const languageList = getLanguageList.value;
		const findIdx = languageList.indexOf(i18n.locale);
		const nextIdx = findIdx + 1 === languageList.length ? 0 : findIdx + 1;
		changeLocaleLang(languageList[nextIdx]);
	};

	const languageMap = {
		[EN]: {
			label: 'English',
			icon: 'icon_en',
			mobIcon: I18_EN_ICON
		},
		[ZH]: {
			label: '简体中文',
			icon: 'icon_cn',
			mobIcon: I18_CN_ICON
		},
		[ZH_HK]: {
			label: '繁體中文',
			icon: 'icon_hk',
			mobIcon: I18_HK_ICON
		}
	};

	return {
		showLanguageBtn,
		handleLangChange,
		changeLocaleLang,
		languageMap,
		enabledLangList
	};
}
